<ng-container>
  <!-- Free Text Field with Table sub-header layout -->
  <table class="layout-fixed" *ngIf="!enableFreeTextFieldListLayout">
    <colgroup>
      <col class="width-100" />
    </colgroup>
    <thead>
      <tr>
        <th>
          <h3>{{customName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngFor="let subtab of freeTextFieldSubTabs">
      <tbody class="secondary-header">
        <tr>
          <td>{{subtab.name}}</td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td class="white-space-pre-wrap" [innerHTML]="(subtab.comment | trim) || '-'"></td>
        </tr>
      </tbody>
    </ng-container>
  </table>

  <!-- Free Text Field with list layout -->
  <table class="layout-fixed" *ngIf="enableFreeTextFieldListLayout">
    <colgroup>
      <col class="width-30" />
      <col class="width-70" />
    </colgroup>
    <thead>
      <tr>
        <th colspan="2">
          <h3>{{customName}}</h3>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="freeTextFieldSubTabs.length">
      <tbody class="secondary-header">
        <tr>
          <td i18n="@@report.reportFreeTextFields.colTopic">Topic</td>
          <td i18n="@@report.reportFreeTextFields.colDescription">Description</td>
        </tr>
      </tbody>
    </ng-container>
    <tbody>
      <tr *ngFor="let subtab of freeTextFieldSubTabs">
        <td class="accent">{{subtab.name}}</td>
        <td class="white-space-pre-wrap" [innerHTML]="(subtab.comment | trim) || '-'"></td>
      </tr>
    </tbody>
  </table>
</ng-container>
